export const prettifyValue = (value) => {
  if (
    value === undefined ||
    value === null ||
    value === "" ||
    value === "<nil>"
  )
    return "-";
  if (typeof value === "object") {
    if (value.Valid) value = value.Bool;
    else return "-";
  }
  if (value === "false" || value === false) return "No";
  if (value === "true" || value === true) return "Yes";
  return value;
};
